// extracted by mini-css-extract-plugin
export default {"account_form":"styles_account_form__nAloD","login_main":"styles_login_main__gwSs0","login_area":"styles_login_area__GMOh9","hide_button":"styles_hide_button__L42ED"};